import './globals/index.scss';

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase())) {
  import('./common/vue/focus-visible-polyfill/focus-visible');
}
